import { useAppSelector } from "../../../../app/store";
import { useGetTrackingSettingLogsQuery } from "../../../../features/tracking/trackingApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import { employeeTrackingTabList } from "./LiveTracking";

export default function LiveTrackingChangeLog() {
  const { authInfo } = useAppSelector((state) => state.auth);
  const {
    data: trackingSettingLogs,
    isError,
    error,
  } = useGetTrackingSettingLogsQuery(authInfo?.business_id || null);

  useError(isError, error, "Get tracking log fail");

  // console.log(trackingSettingLogs);

  return (
    <SidebarLayout
      title="Employee Tracking Setting"
      tabList={employeeTrackingTabList}
    >
      <div className="bg-white p-6 rounded-lg">
        <h2 className="text-lg font-semibold text-[#2D3643] text-[22px] mb-4">
          Change Log
        </h2>

        <div className="">
          {trackingSettingLogs?.data.tracking_setting_logs?.map(
            (log, index) => (
              <div key={index} className="relative pl-6 pb-4">
                <div className="absolute left-[4px] bottom-0 w-[2px] h-full rounded-full bg-[#D7DFE9]"></div>
                <div className="absolute left-0 top-0.5 w-2.5 h-2.5 rounded-full bg-[#1DB469]"></div>

                <div className="flex items-center space-x-3">
                  <span className="text-[#C19C60] text-sm font-medium">
                    {formatDate(log.created_at)} {formatTime(log.created_at)}
                  </span>
                </div>

                <p
                  className={`text-sm text-[#455468] mt-1  pb-4 ${
                    index !==
                      trackingSettingLogs?.data.tracking_setting_logs.length -
                        1 && "border-b border-[#E9EFF6]"
                  }`}
                >
                  {log.log} – by{" "}
                  <span className="text-[#4A72FF] font-medium">
                    {log.created_by_name}
                  </span>
                </p>
              </div>
            )
          )}
        </div>
      </div>
    </SidebarLayout>
  );
}
